module.exports = __webpack_public_path__ + "img/header.52c09f46.png";